export default __webpack_public_path__ + "static/media/App Icon - 120x120.3d8f3a6b.svg";